import type {
  CreateTripTagRequest,
  DeleteTripTagResponse,
  TripTag,
  TripTagCategory,
  TripTagImage,
  TripTagListResponse,
  UpdateTripTagRequest,
} from "@przezmorze/api-types";
import { przezmorzeApi, throwMessageOnStatus } from "../../../api/api";

export type { DeleteTripTagResponse, TripTag, TripTagCategory };

export async function listTripTags(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<TripTagListResponse>("/trip-tags", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function addTripTag(
  category: TripTagCategory,
  name: string,
  isPopular: boolean,
  tagImage?: TripTagImage,
  abortSignal?: AbortSignal,
) {
  const body: CreateTripTagRequest = { category, name, isPopular, image: tagImage };
  try {
    const response = await przezmorzeApi.post<TripTag>("/trip-tags", body, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnStatus(error, 409, "Tag already exists");
  }
}

export async function updateTripTag(
  id: string,
  category: TripTagCategory,
  name: string,
  isPopular: boolean,
  tagImage?: TripTagImage,
  abortSignal?: AbortSignal,
) {
  const body: UpdateTripTagRequest = { category, name, isPopular, image: tagImage };
  const response = await przezmorzeApi.put<TripTag>(`/trip-tags/${id}`, body, {
    signal: abortSignal,
  });
  return response.data;
}

export async function deleteTripTag(id: string, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.delete<DeleteTripTagResponse>(`/trip-tags/${id}`, {
    signal: abortSignal,
  });
  return response.data;
}
